import { Component } from '@angular/core';
import { App, NavController, NavParams, ViewController, ModalController, ToastController, Platform } from 'ionic-angular';
import { LoginPage } from '../login/login';
import { TabsPage } from '../employee/tabs/tabs';
import { DashboardPage } from '../employer/dashboard/dashboard';

//import {Facebook, Google, LinkedIn, OauthBrowser} from 'ionic-cordova-oauth';
import { AuthProvider } from '../../providers/auth/auth'
import { JwtHelperService } from '@auth0/angular-jwt';
import { Storage } from '@ionic/storage'
import { RegisterProvider } from '../../providers/register/register';
import { CompanyCreatePage } from '../createcompany/createcompany';
import { IonicSelectableComponent } from 'ionic-selectable';
import { TabsPageRh } from '../employee/tabsRh/tabsRh';


@Component({
  selector: 'page-signup',
  templateUrl: 'signup.html',
})
export class SignupPage {
  LOCAL:any = 'fr';
  register: any = {
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    phone: '',
    birth_date: '',
    arrival_date: '',
    qualifications: "N/A",
    country: "France",
    postal_code: "00000",
    company_code: '',
    gender: 0,
    avatar: "data:image/jpeg;base64,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",
    highestDiploma: {
      diploma_level:null,
      filiere: null,
      sector: null,
      speciality: null,
      school: null
    },
    service: null,
    position: null,
    contract_type : null
  }

  hobbies: any = [];
  skills: any = [];
  services: any = [];
  positions: any = [];
  contractTypes: any = [];
  filieres: any = [];
  step: number = null;
  selectedSkills: any = null;
  selectedSkillsToImprove: any = null;
  questionList:any = [];
  hobbiesList:any = [];
  answerList:any = [];

  constructor(public app: App, public authProvider: AuthProvider, public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController, public modalCtrl: ModalController, private toastCtrl: ToastController, private storage: Storage,
    public storageProvider: Storage,
    platform: Platform,
    private helper: JwtHelperService, public registerProvider: RegisterProvider, ) {
      platform.ready().then(() => {
        this.storageProvider.get('LOCAL').then(local => {
          if(local){
            this.LOCAL = local;
          }
        })
      })
  }

  ngOnInit() {
    this.loadQuestions();
  }

  loadQuestions(){
    this.registerProvider.getQuestions().subscribe((res) => {
      if(res.success){
        this.questionList = res.data;
      }
    })
  }

  loadServicePositions(){
    this.registerProvider.loadServicePositions(this.register.service, this.register.company_code).subscribe((res) => {
      if(res.success){
        this.positions = res.data;
      }
    })
  }


  fillForm(code) {
    // Get hobbies and skills list
    this.registerProvider.getFormValues(code).subscribe((res) => {
      if (res.success) {
        this.hobbies = res.data.hobbies;
        this.skills = res.data.skills;
        this.services = res.data.services;
        this.positions = res.data.positions;
        this.filieres = res.data.filieres;
        this.contractTypes = res.data.contractTypes;

        this.hobbies.forEach(hobby => {
          hobby.name = this.getNameFromLocal(hobby, 'name')
        });

      }
    })

  }



  ionViewDidLoad() {
  }


  registerAccount() {
    this.authProvider.userRegister(this.register, this.selectedSkills, this.selectedSkillsToImprove, this.hobbiesList, this.answerList).subscribe((res => {
      if (res.success) {
        let toast = this.toastCtrl.create({
          message: "Inscription réussie, bienvenue sur Teambuildr !",
          duration: 4000,
          position: 'top'
        });
        toast.present();
        // Proceed to login

        this.authProvider.userLogin(this.register.email, this.register.password).subscribe(
          res => {
            const token = res.data['token'];
            this.authProvider.user = this.helper.decodeToken(token);

            if (this.authProvider.user.email == this.register.email) {
              this.storage.set("access_token", token);
              this.authProvider.authenticationState.next(true);
              
              if(this.authProvider.user.options.settings_social_network_enabled == false){
                this.dismiss();
                this.app.getRootNav().setRoot(TabsPageRh)
                  .then(() => {
      
                  })
               }
               else{
                this.dismiss();
                this.app.getRootNav().setRoot(TabsPage)
                  .then(() => {})
               }

            }


          },
          (err) => {
            console.log("Devs made an oopsie : " + err)
          }
        );

      } else {
        let toast = this.toastCtrl.create({
          message: "Une erreur s'est produite. Veuillez ré-essayer ulterieurement.",
          duration: 6000,
          position: 'top'
        });
        toast.present();
      }
    }))
  }

  checkCompanyCode(){ // Here we check if the company code is correct and then if the mail was invited by company admins.
    this.registerProvider.checkCompanyCode({ code : this.register.company_code }).subscribe((res) => {
      if(res.success){
        if(res.data == true){
          this.authProvider.checkEmail(this.register.email).subscribe((res) => {
            if(res.success){
              if(res.data[0] == true){
                this.fillForm(this.register.company_code);
                this.step = 0;

              }else{
                let toast = this.toastCtrl.create({
                  message: res.data[1],
                  duration: 6000,
                  position: 'top'
                });
                toast.present();
              }
            }
          })
        }else{
          let toast = this.toastCtrl.create({
            message: "Ce code société n'existe pas.",
            duration: 6000,
            position: 'top'
          });
          toast.present();
        }
      }
    })
  }

   checkEmailAvailable(email): boolean{
    let output:boolean = false;
    this.authProvider.checkEmail(email).subscribe((res) => {
      if (res.success){
        if(res.data == true){
          output = true;
          return output
        }
      }
      return output
    })
    return output
  }

  nextStep() {
    if(this.checkStep()){ // Check for each step if inputs are correctly filled
      this.step < 3 ? this.step++ : null;
    }else{
      let toast = this.toastCtrl.create({
        message: "Merci de vérifier que tous les champs sont bien remplis.",
        duration: 6000,
        position: 'top'
      });
      toast.present();
    }
  }

  previousStep() {
    this.step > 0 ? this.step-- : null;
  }


  goToLogin() {
    this.viewCtrl.dismiss();
    let modal = this.modalCtrl.create(LoginPage, {}, { cssClass: 'modal-gradient' });
    modal.present().then(() => {});
  }

  goToCompanyCreate() {
    this.viewCtrl.dismiss();
    let modal = this.modalCtrl.create(CompanyCreatePage, {}, { cssClass: 'modal-gradient' });
    modal.present().then(() => {});
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  compareWithFn = (o1, o2) => {
    return o1 && o2 ? o1.id === o2.id : o1 === o2;
  };

  checkSkillsLimit(){
    let toast = this.toastCtrl.create({
      message: "Séléctionnez 3 compétences au maxium.",
      duration: 6000,
      position: 'top'
    });
    if(this.selectedSkills.length > 3 ) {
      toast.present();
      this.selectedSkills.splice(3, this.selectedSkills.length - 3)
    }
    console.log('clicked : ', this.selectedSkills.length)
  }

  checkSkillsToImproveLimit(){
    let toast = this.toastCtrl.create({
      message: "Séléctionnez 3 compétences au maxium.",
      duration: 6000,
      position: 'top'
    });
    if(this.selectedSkillsToImprove.length > 3 ) {
      toast.present();
      this.selectedSkillsToImprove.splice(3, this.selectedSkillsToImprove.length - 3)
    }
  }

  compareWith = this.compareWithFn;

  setAnswer(questionId, answer, i){
    if(answer == null){
      this.questionList.splice(i, 1);
    } else{
      this.answerList.push([questionId, answer]);
      this.questionList.splice(i, 1);
    }

    if(this.answerList.length == this.questionList.length + this.answerList.length){ // Goes to final step (Validation)
      this.step = 4;
    }
  }

  checkStep(){
    switch (this.step) {
      case 0:
        if (
          this.register.first_name == '' ||
          this.register.last_name == '' ||
          this.register.birth_date == '' ||
          this.register.service == null ||
          this.register.arrival_date == '' ||
          this.register.position == null ||
          this.register.email == '' ||
          this.register.phone == '' ||
          this.register.password == ''
        ) {
          return false;
        }else{
          return true
        }

      case 1:
        if (
          this.register.highestDiploma.diploma_level == null ||
          this.selectedSkills == null ||
          this.selectedSkillsToImprove == null ||
          this.register.highestDiploma.sector == '' ||
          this.register.highestDiploma.speciality == '' ||
          this.register.highestDiploma.school == ''
        ) {
          return false;
        }else{
          return true
        }

      case 2:
        if (
          this.hobbiesList == null || this.hobbiesList.length == 0
        ) {
          return false;
        }else{
          return true
        }

      default:
        return true;
    }
  }

  getNameFromLocal(object, key){
    if(object !== null){
        if(this.LOCAL == 'fr'){
          return object[key]
        }else{
          return object[key+'_'+this.LOCAL]
        }
      }
    }



}



// WEBPACK FOOTER //
// ./src/pages/signup/signup.ts